export default {
  'app.settings.open': '开',
  'app.settings.registrationDate': '注册日期',
  'app.settings.role': '角色',
  'app.settings.cancelPassword': '取消口令',
  'app.settings.bindPassword': '绑定口令',
  'app.settings.changePassword': '修改密码',
  'app.settings.modifyPermissions': '修改权限',
  'app.settings.depositLimit': '存款限额',
  'app.settings.addUser': '添加用户',
  'app.settings.userName': '用户名',
  'app.settings.pleaseEnterUsername': '请输入用户名',
  'app.settings.accountNumber614': '账号必须为长度6-14位的字母与数组成',
  'app.settings.password': '密码',
  'app.settings.pleaseEnterPassword': '请输入密码',
  'app.settings.singleLimit': '单次限额',
  'app.settings.limitForDay': '当天限额',
  'app.settings.dailyLimitCannot': '当天限额不能低于单次限额!',
  'app.settings.selectRole': '请选择角色',
  'app.settings.sureCancel': '确定取消绑定吗',
  'app.settings.setAccessLimits': '设置存取限额',
  'app.settings.numberMember': '单个会员存款次数',
  'app.settings.manualDepositLimit': '人工存款限额',
  'app.settings.enterManualDepositLimit': '请输入人工存款单次限额',
  'app.settings.enterManualDay': '请输入人工存款当天限额',
  'app.settings.enterNumberDeposits': '请输入人工存款次数',
  'app.settings.preferentialLimit': '优惠存款限额',
  'app.settings.enterPreferentialLimit': '请输入优惠存款单次限额',
  'app.settings.enterDiscountDepositDay': '请输入优惠存款当天限额',
  'app.settings.enterNumberNumberDeposits': '请输入优惠存款次数',
  'app.settings.depositLimitWashing': '返水存款限额',
  'app.settings.enterDepositLimitWashing': '请输入洗码存款单次限额',
  'app.settings.enterDailyDeposit': '请输入洗码存款当天限额',
  'app.settings.enterNumbertheDeposits': '请输入洗码存款次数',
  'app.settings.otherLimits': '其他存款限额',
  'app.settings.enterOtherLimits': '请输入其他存款单次限额',
  'app.settings.enterOtherDay': '请输入其他存款当天限额',
  'app.settings.enterAnotherNumber': '请输入其他存款次数',
  'app.settings.passwordKey': '口令密钥',
  'app.settings.copyKey': '复制密钥',
  'app.settings.hint1': '1、手机下载谷歌动态口令，并安装；',
  'app.settings.hint2': '2、在动态口令app中，点击添加账号。',
  'app.settings.hint3': '3、输入上方提供的秘钥，或选择“扫描条形码”扫描上方二维码。',
  'app.settings.hint4': '4、完成添加，点击绑定口令按钮，完成绑定。',
  'app.settings.characterName': '角色名称',
  'app.settings.permissionSettings': '权限设置',
  'app.settings.addNewRole': '添加新角色',
  'app.settings.roleIdentifier': '角色权限标识',
  'app.settings.onlJpg/png': '只能上传jpg/png文件，且不超过500kb，最佳尺寸：',
  'app.settings.nodeType': '节点类型',
  'app.settings.currentDirectory': '当前目录',
  'app.settings.currentMenu': '当前菜单',
  'app.settings.menu': '菜单',
  'app.settings.enterMenuName': '请输入菜单名称',
  'app.settings.link': '链接',
  'app.settings.addNodeType': '添加节点类型',
  'app.settings.addMenu': '添加菜单',
  'app.settings.addButtonOr': '添加按钮或三级菜单',
  'app.settings.sureEnable/Disable': '确定启用/禁用吗？',
  'app.settings.publicIP': '公网IP',
  'app.settings.ip': 'IP',
  'app.settings.publicIPAddress': '公网IP地址',
  'app.settings.enterIPs': '可输入多个ip地址用,号隔开,最多100个ip',
  'app.settings.pleaseEnterPublicIPAddress': '请输入公网IP地址',
  'app.settings.enterMaxIPCount': '最多只能输入 100 个 IP 地址（当前已输入 {count} 个）',
  'app.settings.bankCard/Alipay': '银行卡/支付宝校验锁定时间',
  'app.settings.bankCard/Alipaytime': '银行卡/支付宝校验次数',
  'app.settings.customerParameters/account': '客服参数/账号',
  'app.settings.linkAddress': '链接地址',

  'app,H5DownloadApp.Serialumber': '序号',
  'app,H5DownloadApp.Downloadcategory': '下载类别',
  'app,H5DownloadApp.openAndroid': '是否开启 安卓设备',
  'app,H5DownloadApp.openiOS': '是否开启 iOS设备',
  'app,H5DownloadApp.downloadAndroid': '安卓下载地址',
  'app,H5DownloadApp.downloadiOS': 'iOS下载地址',
  'app,H5DownloadApp.APPname': 'APP展示名称',
  'app,H5DownloadApp.messageLOGO': '推播讯息LOGO图',
  'app,H5DownloadApp.bottom': '是否开启 底部弹框',
  'app,H5DownloadApp.top': '是否开启 顶部弹框',
  'app,H5DownloadApp.middle': '是否开启 侧边悬浮按钮',
  'app,H5DownloadApp.APPsettings': '下载APP设置',
  'app,H5DownloadApp.Downloadpop': '下载弹窗设置',
  'app,H5DownloadApp.android': '安卓设备',
  'app,H5DownloadApp.ios': 'iOS设备',
  'app,HomeSide.APPDownloadPop': 'APP下载弹窗',
  'app,HomeSide.CustomerServiceCenter': '客服中心',
  'app,HomeSide.Discount': '优惠',
  'app,HomeSide.TopUp': '充值',
  'app,HomeSide.WithdrawMoney': '提款',
  'app,HomeSide.Invite': '邀请',
  'app,HomeSide.PersonalCenter': '个人中心',
  'app,HomeSide.PleaseLink': '请选择链接',
  'app,HomeSide.HomeSidebar': '首页侧边栏',
  'app,HomeSide.MainSwitch': '总开关',
  'app,HomeSide.Tips1': '温馨提示：黑名单中开启状态的设备码、ip地址无法访问客户端。',
  'app,HomeSide.Tips2': '温馨提示：白名单中开启状态的设备码、ip地址不受注册登陆的限制。',
  'app.settings.tip': '提示',
  'app.settings.confirmOperation': '确定操作吗？',
  'app.settings.confirmDelete': '确定删除？',
  'app.settings.selectMenu': '请先选中一个菜单',
  'app.settings.cannotAddChildren': '按钮或三级菜单不能添加子节点',
  'app.settings.addSubNode': '添加子节点',
  'app.settings.addCatalog': '添加目录',
  'app.settings.filterKeyword': '输入关键字进行过滤',
  'app.settings.catalog': '目录',
  'app.settings.submenu': '菜单',
  'app.settings.thirdMenu': '三级菜单',
  'app.settings.btn': '按钮',
  'app.settings.menuName': '菜单名称',
  'app.settings.enterLink': '请输入连接地址 e.g: /xxx/xxx/xx',
  'app.settings.orderNumber': '排序',
  'app.settings.enterOrderNumber': '请输入排序数字',
  'app.settings.sortTip': '数值越小，排名越靠前',
  'app.settings.visible': '是否可见',
  'app.settings.permission': '权限',
  'app.settings.enterPermission': '请输入权限 e.g xxx:xxx:xxx',
};
